var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-parallax",
    { attrs: { src: "/static/images/15.jpg", height: "100%" } },
    [
      _c("center", [
        _c(
          "div",
          {
            staticClass: "card mt-5 mb-5 pt-4 pb-4 pl-4 pr-4",
            staticStyle: { "max-width": "700px", "background-color": "#f9f9fa" }
          },
          [
            _c(
              "v-card",
              { staticClass: "elevation-0" },
              [
                _c(
                  "h6",
                  {
                    staticClass: "title pt-4 ml-4 mr-4",
                    staticStyle: { color: "#FF7D27" }
                  },
                  [_vm._v("Get Your Art Seen today – guaranteed a response.")]
                ),
                _vm._v(" "),
                _c(
                  "v-card-text",
                  { staticStyle: { "margin-top": "-15px" } },
                  [
                    _c("v-container", [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.onSignup($event)
                            }
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "name",
                                      label: "Name",
                                      id: "name",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.name,
                                      callback: function($$v) {
                                        _vm.name = $$v
                                      },
                                      expression: "name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "email",
                                      label: "Email",
                                      id: "email",
                                      type: "email",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.email,
                                      callback: function($$v) {
                                        _vm.email = $$v
                                      },
                                      expression: "email"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "password",
                                      label: "Password",
                                      id: "password",
                                      type: "password",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.password,
                                      callback: function($$v) {
                                        _vm.password = $$v
                                      },
                                      expression: "password"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "confirmedPassword",
                                      label: "Confirm Password",
                                      id: "confirmedPassword",
                                      type: "password"
                                    },
                                    model: {
                                      value: _vm.confirmedPassword,
                                      callback: function($$v) {
                                        _vm.confirmedPassword = $$v
                                      },
                                      expression: "confirmedPassword"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "instagram",
                                      label: "Instagram (or enter N/A)",
                                      id: "instagram",
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.instagram,
                                      callback: function($$v) {
                                        _vm.instagram = $$v
                                      },
                                      expression: "instagram"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.comparePasswords
                                    ? _c(
                                        "v-alert",
                                        {
                                          attrs: { type: "error", value: true }
                                        },
                                        [_vm._v("Passwords do not match")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "" } },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        depressed: "",
                                        large: "",
                                        color: "primary",
                                        type: "submit",
                                        disabled: _vm.comparePasswords
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Sign Up\n                    "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59251026", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59251026","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/artist_signup.vue
// module id = null
// module chunks = 